import { fail, success } from '@helpers/result-helper'
import toast from '@services/toasts/index'
import { isSuccess } from '@/helpers/http-status-helpers'

const getDefaultState = () => {
  return {
    loadingCount: 0,
    crudLoadingCount: 0,
    downloadingFileCount: 0,
    invoices: [],
    invoicesTotal: 0,
    serverCurrentPage: 0,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    moduleName: () => 'invoices',
    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
    isDownloadingFile: (state) => state.downloadingFileCount > 0,
    invoices: (state) => state.invoices,
    invoicesTotal: (state) => state.invoicesTotal,
    serverCurrentPage: (state) => state.serverCurrentPage,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    SET_INVOICES(state, invoices) {
      state.invoices = invoices
    },
    SET_INVOICES_TOTAL(state, total) {
      state.invoicesTotal = total
    },
    SET_SERVER_CURRENT_PAGE(state, page) {
      state.serverCurrentPage = page
    },
    START_DOWNLOADING_FILE(state) {
      state.downloadingFileCount++
    },
    FINISH_DOWNLOADING_FILE(state) {
      state.downloadingFileCount--
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async loadInvoices({ commit }, { page, pageSize }) {
      commit('START_LOADING')

      try {
        const response = await this.$api.invoices.get('', {
          skip: (page - 1) * pageSize,
          take: pageSize,
        })

        if (isSuccess(response.status)) {
          commit('SET_INVOICES', response.data.invoices)
          commit('SET_INVOICES_TOTAL', response.data.total)
          commit('SET_SERVER_CURRENT_PAGE', response.data.currentPage)

          return success(response.data)
        }
      } catch {
        toast.error(this.$i18n.t('error.errorGenericApiErrorText'))
        return fail()
      } finally {
        commit('FINISH_LOADING')
      }
    },
    async getOustandingInvoicesCount({ commit }) {
      commit('START_LOADING')
      try {
        const response = await this.$api.invoices.getOustandingInvoicesCount()
        if (isSuccess(response.status)) {
          return success(response.data.outstandingInvoicesCount)
        }
      } catch {
        toast.error(`Failed to load Oustanding Invoices Count`)
        return fail()
      } finally {
        commit('FINISH_LOADING')
      }
    },
    async downloadInvoiceFile({ commit }, invoiceId) {
      commit('START_DOWNLOADING_FILE')

      try {
        const response = await this.$api.invoices.getInvoiceFile(invoiceId)

        if (isSuccess(response.status)) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' })
          )
          return success(url)
        }
      } catch (ex) {
        let toastErrorMessage = this.$i18n.t('error.errorGenericApiErrorText')
        // Try to resolve error response. Response type is Blob, need to convert
        // from blob to json
        try {
          const responseObject = JSON.parse(await ex.response.data.text())
          if (responseObject) toastErrorMessage = responseObject.message
        } catch {}

        toast.error(toastErrorMessage)
        return fail()
      } finally {
        commit('FINISH_DOWNLOADING_FILE')
      }
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
